import { LinearFilter, LinearMipmapLinearFilter, LinearMipMapLinearFilter, LinearMipmapNearestFilter, LinearMipMapNearestFilter, NearestFilter, NearestMipmapLinearFilter, NearestMipMapLinearFilter, NearestMipmapNearestFilter, NearestMipMapNearestFilter } from 'three';

export const textureFilterValues = {
   NearestFilter,
   NearestMipmapNearestFilter,
   NearestMipMapNearestFilter,
   NearestMipmapLinearFilter,
   NearestMipMapLinearFilter,
   LinearFilter,
   LinearMipmapNearestFilter,
   LinearMipMapNearestFilter,
   LinearMipmapLinearFilter,
   LinearMipMapLinearFilter,
};

export const textureFilterNames: { [v: number]: TextureFilter } = {};
Object.keys(textureFilterValues).forEach((k: TextureFilter) =>
{
    textureFilterNames[textureFilterValues[k]] = k;
});

export type TextureFilter = keyof typeof textureFilterValues;
